import storage from "../services/storageAdapter";
import { StorageService } from "./ports";

type Deps = {
	storage: StorageService;
};

const defaultDeps: Deps = {
	storage,
};

function planSorting(status: boolean, deps: Deps = defaultDeps): boolean {
	const { storage } = deps;

	storage.setIsNeedToSort(status);

	return storage.getIsNeedToSort();
}

export default planSorting;
